<template>
  <div @contextmenu="selectComponentDEV($event, schema.model)" :class="[getSelectedDEV && 'dev-selected-component']">
    <v-icon v-bind="schema.attributes" :id="setId(schema.model)" :name="schema.model">
      {{ value ? value : schema.attributes.icon }}
    </v-icon>
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';

export default {
  mixins: [abstractField, devComponentMixin],
  methods: {
    setId(field) {
      return this.formOptions.mode === 'list' ? `${field}_${this.formOptions.index}` : field;
    }
  }
};
</script>
